/* ══════════════════════════════════════════════════════════════════
   [D-768] «📍 Звідки» — переклад міток джерела переходу в наш застосунок.

   OWNER 30.10: «зроби колонку "звідки"». Колонка `app_clicks.src` існувала
   з D-548, але стояла порожня: мітку ніхто не ставив, тож усі 17 переходів
   були «нізвідки». Тепер її ставить той екран, що веде на продукт
   (`miniapp/src/openApp.js` і його три виклики), а тут — єдине місце, де
   теги стають словами: три списки (👆 Наші APP, картка партнера, картка
   юзера) мусять називати те саме однаково.

   🔴 Порожня мітка — це НЕ помилка: так виглядають переходи, записані до
   30.10. Пишемо про це словами, щоб порожнє не читалось як «невідомо звідки».
   ══════════════════════════════════════════════════════════════════ */

export const SRC_LABEL = {
  hub: '📱 Хаб → Наші APP',
  studio: '🎬 Студія: заставка очікування',
  pv_hub: '👁 Презентація (з Хаба)',
  pv_studio: '👁 Презентація (зі Студії)',
  pv: '👁 Презентація',
  preview: '👁 Презентація',   // мітка з D-548, до того як джерело почали розрізняти
};

export const SRC_OLD = '◻️ до 30.10 (ще не записували)';

export const srcLabel = (s) => SRC_LABEL[s] || (s ? '❔ ' + s : SRC_OLD);

/** «Звідки» одним рядком, найчастіше джерело першим. '' — показувати нічого. */
export function srcLine(srcs) {
  const k = Object.keys(srcs || {});
  if (!k.length) return '';
  return k.sort((a, b) => srcs[b] - srcs[a]).map(x => srcLabel(x) + ' ×' + srcs[x]).join(' · ');
}
